import { Button } from '@repo/ui'
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router'
import { Building2, LogOut, Mail } from 'lucide-react'
import { useEffect } from 'react'

import { InvitationsList } from '@/features/invitations/invitations-list'
import { useAuth } from '@/hooks/use-auth'

export const Route = createFileRoute('/sem-organizacao')({
  component: NoOrgPage,
})

function NoOrgPage() {
  const navigate = useNavigate()
  const { user, memberships, loading, signOut } = useAuth()

  useEffect(() => {
    if (loading) return

    if (!user) {
      void navigate({ to: '/entrar', search: { returnTo: undefined } })
      return
    }

    if (memberships.length > 0) {
      void navigate({ to: '/inbox' })
    }
  }, [loading, memberships.length, navigate, user])

  if (loading || !user) return null

  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center px-4">
      <div className="w-full max-w-md space-y-6">
        <div className="text-center">
          <h1 className="text-foreground text-2xl font-bold">
            Bem-vindo ao AgroSDR
          </h1>
          <p className="text-muted-foreground mt-2 text-sm">
            Você ainda não pertence a nenhuma organização. Como deseja
            continuar?
          </p>
        </div>

        <div className="grid gap-4">
          <div className="border-border space-y-3 rounded-lg border p-5">
            <div className="flex items-center gap-3">
              <div className="bg-muted flex h-9 w-9 shrink-0 items-center justify-center rounded-md">
                <Mail className="text-muted-foreground h-5 w-5" />
              </div>
              <div>
                <p className="text-foreground text-sm font-medium">
                  Seus convites
                </p>
                <p className="text-muted-foreground text-xs">
                  Convites enviados para {user.email}
                </p>
              </div>
            </div>
            <InvitationsList
              onAccepted={() => void navigate({ to: '/inbox' })}
            />
            <p className="text-muted-foreground text-xs">
              Não vê seu convite? Peça ao administrador para convidar o e-mail
              acima.
            </p>
          </div>

          <div className="border-border space-y-3 rounded-lg border p-5">
            <div className="flex items-center gap-3">
              <div className="bg-muted flex h-9 w-9 shrink-0 items-center justify-center rounded-md">
                <Building2 className="text-muted-foreground h-5 w-5" />
              </div>
              <div>
                <p className="text-foreground text-sm font-medium">
                  Quero criar minha organização
                </p>
                <p className="text-muted-foreground text-xs">
                  Assinar um plano e configurar do zero
                </p>
              </div>
            </div>
            <Link to="/onboarding">
              <Button className="w-full">Começar agora</Button>
            </Link>
          </div>
        </div>

        <div className="text-center">
          <button
            type="button"
            onClick={() => void signOut()}
            className="text-muted-foreground hover:text-foreground inline-flex items-center gap-1.5 text-sm transition-colors"
          >
            <LogOut className="h-3.5 w-3.5" />
            Sair da conta
          </button>
        </div>
      </div>
    </div>
  )
}
